import { EMarkAllAsReadNotificationActionTypes, TMarkAllAsReadNotificationLoading } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const markAllAsReadLoading: () => TMarkAllAsReadNotificationLoading =
  actionGenerator<EMarkAllAsReadNotificationActionTypes.Loading>(EMarkAllAsReadNotificationActionTypes.Loading);
